import { Observable, switchMap } from "rxjs";
import { Injectable, inject } from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { AuthService } from "@auth/services/auth/auth.service";
import { SessionStorageService } from "@shared/services/session-storage.service";
import { SessionStorageKeys } from "@shared/services/static/session-storage-keys";
import { AppConfigService } from "@api/services/app-config.service";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    private readonly oauthService = inject(OAuthService);
    private readonly authService = inject(AuthService);
    private readonly sessionStorageService = inject(SessionStorageService);
    private readonly appConfigService = inject(AppConfigService);
    private readonly appConfig = this.appConfigService.appConfig;

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.includes(this.appConfig().identityServer)) {
            if (req.url.includes("connect/token")) {
                const updates = Array.from(Object.assign({}, req.body).updates);

                return this.authService.getClientAuthJwt().pipe(
                    switchMap((res) => {
                        this.sessionStorageService.removeItem(SessionStorageKeys.AuthCode);

                        updates.push({ param: "client_assertion", value: res, op: "s" });
                        req.body.updates = updates;

                        return next.handle(req);
                    }),
                );
            }
        }

        const accessToken = this.oauthService.getAccessToken();

        if (accessToken) {
            const cloned = req.clone({
                headers: req.headers.set("Authorization", `Bearer ${accessToken}`),
            });

            return next.handle(cloned);
        } else return next.handle(req);
    }
}
